export class FileConfig {
  fileName: string;
  width: number;
  height: number;
  length: number;
  page: string;
  last: boolean;
  lockRubric: boolean;
  includeRubric: boolean;
  selected: boolean;
  pageRotation: boolean;
}
